import React from "react";
import { ArrowUp } from "lucide-react";

const TIERS = [
  { min: 1000, label: "Legend", color: "var(--tt-yellow)" },
  { min: 250, label: "Mogul", color: "var(--tt-primary)" },
  { min: 50, label: "Critic", color: "var(--tt-purple)" },
  { min: 10, label: "Cinephile", color: "#22c55e" },
];

export function tierFor(karma = 0) {
  for (const t of TIERS) if (karma >= t.min) return t;
  return null;
}

export default function KarmaBadge({ karma = 0, size = "sm" }) {
  if (!karma) return null;
  const t = tierFor(karma);
  const text = t ? `${t.label} · ${karma}` : `${karma}`;
  const color = t?.color || "var(--tt-text-muted)";
  return (
    <span
      data-testid="karma-badge"
      className={`inline-flex items-center gap-0.5 font-mono-tt ${size === "lg" ? "text-xs px-2 py-0.5" : "text-[10px] px-1.5 py-0.5"} rounded-full border`}
      style={{ color, borderColor: `${color}55`, background: `${color}15` }}
    >
      <ArrowUp className={size === "lg" ? "w-3 h-3" : "w-2.5 h-2.5"} />
      {text}
    </span>
  );
}
